import { useSelector } from 'react-redux'
import * as ROLES_CONSTANTS from '../../../constants/roles'

const useWalletFilters = () => {
  const filters = useSelector((store) => store.walletReducer.filters)

  const userRoles = useSelector((store) => store.currentUserReducer.roles)

  const hasPriorityMatricesFilter = filters?.priorityMatrices?.length > 0

  const canViewPartner = userRoles.includes(
    ROLES_CONSTANTS.FILTER_PARTNER_GET_ALL
  )
  const canViewNetwork = userRoles.includes(
    ROLES_CONSTANTS.FILTER_GEOGRAPHY_NETWORK_GET_ALL
  )
  const canViewSubsidiary = userRoles.includes(
    ROLES_CONSTANTS.FILTER_GEOGRAPHY_SUBSIDIARY_GET_ALL
  )
  const canViewGroup = userRoles.includes(
    ROLES_CONSTANTS.FILTER_STORE_GROUP_GET_ALL
  )
  const canViewProduct = userRoles.includes(
    ROLES_CONSTANTS.FILTER_STORE_PRODUCT_GET_ALL
  )
  const canViewStatus = userRoles.includes(
    ROLES_CONSTANTS.FILTER_STORE_STATUS_GET_ALL
  )

  const canGetSegmentsAndSubsegments = userRoles.includes(
    ROLES_CONSTANTS.FILTER_STORE_SEGMENT_GET_ALL
  )

  const canViewPriorityMatrices = userRoles.includes(
    ROLES_CONSTANTS.FILTER_STORE_PRIORITY_MATRICES_GET_ALL
  )

  return {
    canViewPartner,
    canViewNetwork,
    canViewSubsidiary,
    canViewGroup,
    canViewProduct,
    canViewStatus,
    canGetSegmentsAndSubsegments,
    canViewPriorityMatrices,
    filters,
    hasPriorityMatricesFilter
  }
}

export default useWalletFilters
